import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LogoTwitter = function LogoTwitter(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({}, newProps), {}, {
    className: classNames('sol-illustration', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "logo.twitter"
  }, /*#__PURE__*/React__default.createElement("g", {
    id: "logo-twitter"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    d: "M30 7.57692C28.9694 8.0142 27.8637 8.31077 26.7019 8.44317C27.8881 7.76289 28.7962 6.68389 29.2266 5.40211C28.1138 6.03209 26.8855 6.48954 25.5768 6.73751C24.5287 5.66687 23.038 5 21.3845 5C18.2124 5 15.6404 7.463 15.6404 10.499C15.6404 10.9296 15.6911 11.3502 15.7891 11.7523C11.016 11.5227 6.78357 9.33287 3.95085 6.00528C3.45568 6.81624 3.17399 7.76118 3.17399 8.76988C3.17399 10.6783 4.18881 12.3622 5.72854 13.3474C4.78719 13.3172 3.90185 13.0692 3.12677 12.657V12.7257C3.12677 15.3898 5.10741 17.6132 7.73365 18.1192C7.25248 18.2432 6.74509 18.3119 6.22018 18.3119C5.84927 18.3119 5.49058 18.2767 5.13889 18.2097C5.87023 20.3963 7.99087 21.9863 10.5034 22.0299C8.53851 23.5044 6.06097 24.3807 3.36999 24.3807C2.90634 24.3807 2.44965 24.3539 2 24.3053C4.54229 25.8685 7.56048 26.78 10.8044 26.78C21.3706 26.78 27.1463 18.3991 27.1463 11.1307L27.1271 10.4186C28.2556 9.64783 29.2319 8.67941 30 7.57692Z",
    fill: "#1DA1F2"
  }))));
};

export { LogoTwitter };
